
import Loading from 'vux/src/components/loading/index.vue'

export default {
data() {
return {

}
},
components:{
Loading
},
props:['shows','text_1']
}



// WEBPACK FOOTER //
// ./src/components/loadingPage.vue